import React from 'react';

const renderParagraph = (text, color = 'rgba(184, 184, 184, 1)') => (
  <p style={{ color }}>{text}</p>
);

export default renderParagraph;
